import { StageType } from 'api-clients/monolith/models/StageType';

// Mirrors Stage::FINAL_STAGES in the monolith, enforced by tools/contract-mirrors.
// The mirror matches on the type annotation, so both lists stay ReadonlyArray<string>.
export const finalStageTypes: ReadonlyArray<string> = [
  'HiredStage',
  'RejectedStage',
  'ArchivedStage',
];

// Mirrors Stage::INVISIBLE_STAGES in the monolith, enforced the same way. Strings
// rather than StageType because the generated union omits EmailPdfStage.
export const invisibleStageTypes: ReadonlyArray<string> = [
  'RuleStage',
  'EmailPdfStage',
  'DistributeApplicantsRuleStage',
];

export const terminalStagesHash: Record<string, boolean> = Object.fromEntries(
  finalStageTypes.map(type => [type, true]),
);

// Stages::Cloning refuses both sets, so offering one as a clone source is a dead
// end: the recruiter picks a stage and gets a 422 back. The opening-sourced picker
// filters on this; the workflow-sourced one asks the API for clonable stages so the
// refused types never take a page slot.
export const nonCloneableStageTypes: ReadonlySet<string> = new Set([
  ...finalStageTypes,
  ...invisibleStageTypes,
]);

export const stageTypes: StageType[] = [
  'AccurateStage',
  'ArchivedStage',
  'BackgroundCheckerStage',
  'CheckrCanada::Stage',
  'CustomStage',
  'DataCollectionStage',
  'DistributeApplicantsRuleStage',
  'DocumentSignatureStage',
  'DocumentSigningStage',
  'FountainDocumentSigningStage',
  'HiredStage',
  'I9FormStage',
  'LearningStage',
  'MultiStage',
  'NewCheckrCanada::Stage',
  'OnfidoStage',
  'PartnerStage',
  'RehireCheckStage',
  'RejectedStage',
  'RuleStage',
  'SchedulerStage',
  'SchoolkeepStage',
  'SterlingStage',
  'TechCheckStage',
  'VideoRecordingStage',
  'W4FederalFormStage',
  'W4StateFormStage',
];
